import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CheckupTag } from '@companion-professional/dctypes';
import { setCheckupLocationTag } from '../lib/api';

export type UpdateCheckupTagValues = {
  checkupId: string;
  tag: CheckupTag;

  // petId is used to invalidate the pet-checkups query after the checkup tag is updated; not used in the actual
  // request.
  petId: string;
};

// useSetCheckupLocationTag is a hook that returns a function that updates the checkup location tag (e.g. to in_home).
export const useSetCheckupLocationTag = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending, error } = useMutation({
    mutationFn: async (values: UpdateCheckupTagValues) => {
      const res = await setCheckupLocationTag(values.checkupId, values.tag);
      await queryClient.invalidateQueries({
        queryKey: ['checkup-request', values.checkupId]
      });
      await queryClient.invalidateQueries({
        queryKey: ['active-checkups']
      });
      await queryClient.invalidateQueries({
        queryKey: ['pet-checkups', values.petId]
      });
      return res;
    }
  });

  return {
    setCheckupLocationTag: mutateAsync,
    isPending,
    error
  };
};
